import { useState } from 'react';
import { roles } from '../../config/roles';
import { UserCircle, Briefcase } from 'lucide-react';

interface RoleSelectProps {
  selectedRole: string;
  onChange: (value: string) => void;
  isProcessing: boolean;
  selectedMatter: string;
  onMatterChange: (value: string) => void;
}

export default function RoleSelect({ selectedRole, onChange, isProcessing, selectedMatter, onMatterChange }: RoleSelectProps) {
  const [showMatterDropdown, setShowMatterDropdown] = useState(false);

  const handleRoleChange = (roleId: string) => {
    onChange(roleId);
    if (roleId === 'controlador-interno' || roleId === 'parecerista-juridico') {
      setShowMatterDropdown(true);
    } else {
      setShowMatterDropdown(false);
      onMatterChange('');
    }
  };


  return (
    <div>
      <div className="mb-6">
        <label className="flex items-center space-x-2 text-sm font-medium text-navy-700 dark:text-navy-200 mb-2">
          <UserCircle className="h-4 w-4 text-accent-500 dark:text-accent-400" />
          <span>Papel do Analista</span>
        </label>
        <select
          value={selectedRole}
          onChange={(e) => handleRoleChange(e.target.value)}
          className="mt-1 block w-full rounded-lg px-4 py-3 border border-navy-300 dark:border-navy-600 bg-white dark:bg-navy-800 text-navy-900 dark:text-navy-100 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30 transition-all duration-200"
          required
          disabled={isProcessing}
        >
          <option value="">Selecione um papel</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>
      </div>

      {showMatterDropdown && (
        <div className="mb-6">
          <label className="flex items-center space-x-2 text-sm font-medium text-navy-700 dark:text-navy-200 mb-2">
            <Briefcase className="h-4 w-4 text-accent-500 dark:text-accent-400" />
            <span>Matéria</span>
          </label>
          <select
            value={selectedMatter}
            onChange={(e) => onMatterChange(e.target.value)}
            className="mt-1 block w-full rounded-lg px-4 py-3 border border-navy-300 dark:border-navy-600 bg-white dark:bg-navy-800 text-navy-900 dark:text-navy-100 focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30 transition-all duration-200"
            required
            disabled={isProcessing}
          >
            <option value="">Selecione a matéria</option>
            <option value="pessoal">Pessoal</option>
            <option value="licitacoes">Licitações</option>
            <option value="orcamentario">Orçamentário</option>
            <option value="patrimonio">Patrimônio</option>
          </select>
        </div>
      )}
    </div>
  );
}
